import { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import {
  useSearchParams,
} from "react-router-dom";

import {
  allStudentFeeReport,
} from "../../api/Student";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import DownloadExcel from "../master/DownloadExcel";
import { PrintPage } from "../master/Print";
import { batchList } from "../../api/Batch";

export default function BatchDueFeesReportAllStudents(route) {
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [filters, setFilters] = useState({});
  const [BatchStudents, setBatchStudents] = useState({});
  const [batches, setBatches] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const batch_id = searchParams.get("batch_id") || "";
  const batchId = searchParams.get("batch_id") || "";
  // const [batchId, setBatchId] = useState(batch_id || "");

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
    setFilters((prev) => {
      if (prev.session_id || !activeSession) return prev;
      return { ...prev, session_id: activeSession };
    });
  }, [sessions]);

  const buildQuery = () => {
    let addUrl = "with=feetype&batch_id=" + batch_id + "&id=" + batch_id;
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) addUrl += `&${key}=${encodeURIComponent(value)}`;
    });
    return addUrl;
  };

  const getBatches = async () => {
    setLoading(true);

    try {
      const response = await batchList(buildQuery());

      if (response.data.status) {
        const batchData = response?.data?.data || [];

        // Set all batches
        setBatches(batchData);

        // Find selected batch from newly fetched data
        const selectedBatch = batchData.find(
          (b) => String(b?.id) === String(batch_id),
        );

        console.log("Selected Batch:", selectedBatch);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.response?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getStudentsofBatch = async () => {
    setLoading(true);
    try {
      const response = await allStudentFeeReport(buildQuery());
      if (response.data.status) {
        setBatchStudents(response?.data?.data || {});
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.response?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBatches();
    // getStudentFeeReportBatchWise();
    getStudentsofBatch();
  }, [filters]);

  const inr = (n) =>
    "₹ " +
    Number(n || 0).toLocaleString("en-IN", {
      maximumFractionDigits: 0,
    });

  const handleDownload = async (type = "excel") => {
    setLoading(true);

    try {
      const students = Array.isArray(BatchStudents) ? BatchStudents : [];

      if (!students.length) {
        SweetAlertShow("info", "Info", "No records found");
        return;
      }

      const downloadData = students.map((student, index) => {
        // -----------------------------
        // Batch Fee
        // -----------------------------
        const batchFees = student.student_batch_n_fees || [];

        const batchFee = batchFees.reduce(
          (total, fee) => total + Number(fee.final_fee || 0),
          0,
        );

        const batchDiscount = batchFees.reduce(
          (total, fee) => total + Number(fee.total_discount || 0),
          0,
        );

        const batchPaid = batchFees.reduce(
          (total, fee) => total + Number(fee.total_paid || 0),
          0,
        );

        const batchDue = batchFees.reduce(
          (total, fee) => total + Number(fee.total_due || 0),
          0,
        );

        // -----------------------------
        // Hostel Fee
        // -----------------------------
        const hostelFees = student.student_hostel_n_fees || [];

        const hostelFee = hostelFees.reduce(
          (total, fee) => total + Number(fee.final_amount || 0),
          0,
        );

        const hostelPaid = hostelFees.reduce(
          (total, fee) => total + Number(fee.paid_amount || 0),
          0,
        );

        const hostelDue = hostelFees.reduce(
          (total, fee) => total + Number(fee.left_amount || 0),
          0,
        );

        // -----------------------------
        // Library Fee
        // -----------------------------
        const libraryFees = student.student_library_n_fees || [];

        const libraryFee = libraryFees.reduce(
          (total, fee) => total + Number(fee.final_amount || 0),
          0,
        );

        const libraryPaid = libraryFees.reduce(
          (total, fee) => total + Number(fee.paid_amount || 0),
          0,
        );

        const libraryDue = libraryFees.reduce(
          (total, fee) => total + Number(fee.left_amount || 0),
          0,
        );

        // -----------------------------
        // Transport Fee
        // -----------------------------
        const transportFees = student.student_transport_n_fees || [];

        const transportFee = transportFees?.reduce(
          (total, fee) => total + Number(fee.total_final_fee || 0),
          0,
        );

        const transportPaid = transportFees?.reduce(
          (total, fee) => total + Number(fee.total_paid || 0),
          0,
        );

        const transportDue = transportFees?.reduce(
          (total, fee) => total + Number(fee.total_due || 0),
          0,
        );

        // -----------------------------
        // Overall Totals
        // -----------------------------
        const totalPayable = batchFee + hostelFee + libraryFee + transportFee;

        const totalPaid = batchPaid + hostelPaid + libraryPaid + transportPaid;

        const totalDue = batchDue + hostelDue + libraryDue + transportDue;

        return {
          "#": index + 1,
          "Registration No": student.registration_no,
          Student: student.name,
          "Father Name": student.father_name,

          "Batch Fee": batchFee,
          Hostel: hostelFee,
          Library: libraryFee,
          Transport: transportFee,

          Discount: batchDiscount,

          "Payable Fee": totalPayable,
          "Received Fee": totalPaid,
          Due: totalDue,

          Status: totalDue > 0 ? "Due" : "Paid",
        };
      });

      // -----------------------------
      // TOTAL ROW
      // -----------------------------
      const totalRow = {
        "#": "",
        "Registration No": "",
        Student: "TOTAL",
        "Father Name": "",

        "Batch Fee": downloadData.reduce(
          (t, r) => t + Number(r["Batch Fee"] || 0),
          0,
        ),

        Hostel: downloadData.reduce((t, r) => t + Number(r.Hostel || 0), 0),

        Library: downloadData.reduce((t, r) => t + Number(r.Library || 0), 0),

        Transport: downloadData.reduce(
          (t, r) => t + Number(r.Transport || 0),
          0,
        ),

        Discount: downloadData.reduce((t, r) => t + Number(r.Discount || 0), 0),

        "Payable Fee": downloadData.reduce(
          (t, r) => t + Number(r["Payable Fee"] || 0),
          0,
        ),

        "Received Fee": downloadData.reduce(
          (t, r) => t + Number(r["Received Fee"] || 0),
          0,
        ),

        Due: downloadData.reduce((t, r) => t + Number(r.Due || 0), 0),

        Status: "",
      };

      downloadData.push(totalRow);

      // -----------------------------
      // Download / Print
      // -----------------------------
      const now = new Date();

      const fileName = `Batch_Fee_Report_${now.getFullYear()}_${
        now.getMonth() + 1
      }_${now.getDate()}_${now.getHours()}_${now.getMinutes()}`;

      if (type === "excel") {
        DownloadExcel(downloadData, [], fileName, []);
      } else {
        PrintPage(downloadData);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message || err?.message || "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    {/* Header / Filters */}
                    <div className="card border-0 shadow-sm rounded-4 p-3 mb-3">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="bg-primary text-white rounded-3 d-flex align-items-center justify-content-center fs-5"
                            style={{ width: 46, height: 46 }}
                          >
                            <i className="ri-money-rupee-circle-line"></i>
                          </div>
                          <div>
                            <h5 className="m-0 fw-bold">
                              Batch Wise Students Fees Report / Dashboard
                            </h5>
                            <small className="text-muted">
                              Monitor fees collection and analytics
                            </small>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <div
                            className="form-floating form-floating-outline"
                            style={{ minWidth: "220px" }}
                          >
                            <select
                              className="form-select rounded-3"
                              value={filters?.session_id || ""}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  session_id: e.target.value,
                                })
                              }
                            >
                              {sessions?.map((s) => (
                                <option key={s?.id} value={s?.id}>
                                  {s.session} :{" "}
                                  {s.status === "1" ? "Active" : "Inactive"}
                                </option>
                              ))}
                            </select>
                            <label>Session</label>
                          </div>

                          <div
                            className="form-floating form-floating-outline"
                            style={{ minWidth: "220px" }}
                          >
                            {/* {JSON.stringify(batches)} */}
                            <select
                              className="form-select rounded-3"
                              value={batchId}
                              onChange={(e) => {
                                const selectedBatchId = e.target.value;
                                setSearchParams({
                                  batch_id: selectedBatchId,
                                });

                                setFilters((prev) => ({
                                  ...prev,
                                  batch_id: selectedBatchId,
                                }));
                              }}
                            >
                              <option value="">Select Batch</option>

                              {batches?.map((b) => (
                                <option key={b?.id} value={b?.id}>
                                  {b?.title}
                                </option>
                              ))}
                            </select>
                            <label>Batch</label>
                          </div>

                          <div
                            className="form-floating form-floating-outline"
                            style={{ minWidth: "180px" }}
                          >
                            <select
                              className="form-select rounded-3"
                              value={filters?.rte_status || ""}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  rte_status: e.target.value,
                                })
                              }
                            >
                              <option value="">All</option>
                              <option value="RTE">RTE</option>
                              <option value="NON-RTE">NON-RTE</option>
                            </select>
                            <label>RTE Status</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Batch-wise Report */}
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-3">
                      {/* Header */}
                      <div className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="rounded-3 d-flex align-items-center justify-content-center text-white"
                            style={{
                              width: 44,
                              height: 44,
                              background:
                                "linear-gradient(135deg, #10b981, #22c55e)",
                            }}
                          >
                            <i className="ri-stack-line fs-5"></i>
                          </div>

                          <div>
                            <h6 className="m-0 fw-bold">
                              Batch Wise Students Fee Report
                            </h6>
                            <small className="text-muted">
                              Fees summary grouped by batch Students
                            </small>
                          </div>
                        </div>
                        <div className="d-flex gap-2">

                          <button
                            type="button"
                            className="btn btn-outline-primary rounded-3"
                            onClick={() => handleDownload("excel")}
                          >
                            <i className="ri-file-excel-2-line me-2"></i>{" "}
                            Download
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-info rounded-3"
                            onClick={() => handleDownload("print")}
                          >
                            <i className="ri-printer-line me-2"></i> Print
                          </button>
                        </div>
                      </div>

                      {/* Table */}
                      {/* <div className="table-responsive"></div> */}
                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0 table-bordered">
                          <thead>
                            <tr className="text-uppercase small text-muted">
                              <th className="ps-4">#</th>
                              <th>Student</th>
                              <th className="text-end">Batch Fee</th>
                              <th className="text-end">Hostel</th>
                              <th className="text-end">Library</th>
                              <th className="text-end">Transport</th>
                              <th className="text-end">Discount</th>
                              <th className="text-end">Payable</th>
                              <th className="text-end">Paid</th>
                              <th className="text-end">Due</th>
                              <th className="text-center pe-4">Status</th>
                            </tr>
                          </thead>

                          <tbody>
                            {!BatchStudents?.length ? (
                              <tr>
                                <td
                                  colSpan="11"
                                  className="text-center py-5 text-muted"
                                >
                                  No students available
                                </td>
                              </tr>
                            ) : (
                              BatchStudents.map((student, i) => {
                                /*
                                 * ============================================================
                                 * BATCH FEE
                                 * ============================================================
                                 */

                                const batchFees =
                                  student.student_batch_n_fees || [];

                                const batch_total_fee = batchFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.total_fee || 0),
                                  0,
                                );

                                const batchFee = batchFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.final_fee || 0),
                                  0,
                                );

                                const batchDiscount = batchFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.total_discount || 0),
                                  0,
                                );

                                const batchPaid = batchFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.total_paid || 0),
                                  0,
                                );

                                const batchDue = batchFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.total_due || 0),
                                  0,
                                );

                                /*
                                 * ============================================================
                                 * BATCH FEE TYPE BREAKDOWN
                                 * ============================================================
                                 */

                                const batchFeeDetails = batchFees.flatMap(
                                  (batchFeeItem) =>
                                    batchFeeItem.student_fee_details || [],
                                );

                                const feeTypeTotals = batchFeeDetails.reduce(
                                  (acc, fee) => {
                                    const feeType = fee.fee_type || "Other Fee";

                                    if (!acc[feeType]) {
                                      acc[feeType] = {
                                        actual: 0,
                                        discount: 0,
                                        final: 0,
                                        paid: 0,
                                        due: 0,
                                      }; 
                                    }

                                    acc[feeType].actual += Number(
                                      fee.actual_amount || 0,
                                    );

                                    acc[feeType].discount += Number(
                                      fee.discount || 0,
                                    );

                                    acc[feeType].final += Number(
                                      fee.final_amount || 0,
                                    );

                                    acc[feeType].paid += Number(
                                      fee.paid_amount || 0,
                                    );

                                    acc[feeType].due += Number(
                                      fee.due_amount || 0,
                                    );

                                    return acc;
                                  },
                                  {},
                                );

                                const hostelFees =
                                  student.student_hostel_n_fees || [];

                                const hostelFee = hostelFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.final_amount || 0),
                                  0,
                                );

                                const hostelPaid = hostelFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.paid_amount || 0),
                                  0,
                                );

                                const hostelDue = hostelFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.left_amount || 0),
                                  0,
                                );

                                const libraryFees = student.student_library_n_fees || [];

                                const libraryFee = libraryFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.final_amount || 0),
                                  0,
                                );

                                const libraryPaid = libraryFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.paid_amount || 0),
                                  0,
                                );

                                const libraryDue = libraryFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.left_amount || 0),
                                  0,
                                );

                                /*
                                 * ============================================================
                                 * TRANSPORT FEE
                                 * ============================================================
                                 */

                                const transportFees =
                                  student.student_transport_n_fees || [];

                                const transportFee = transportFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.final_amount || 0),
                                  0,
                                );

                                const transportPaid = transportFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.paid_amount || 0),
                                  0,
                                );

                                const transportDue = transportFees.reduce(
                                  (total, fee) =>
                                    total + Number(fee.left_amount || 0),
                                  0,
                                );

                                /*
                                 * ============================================================
                                 * OVERALL TOTALS
                                 * ============================================================
                                 */

                                const totalPayable =
                                  batchFee +
                                  hostelFee +
                                  libraryFee +
                                  transportFee;

                                const totalPaid =
                                  batchPaid +
                                  hostelPaid +
                                  libraryPaid +
                                  transportPaid;

                                const totalDue =
                                  batchDue +
                                  hostelDue +
                                  libraryDue +
                                  transportDue;

                                const feeStatus = totalDue > 0 ? "Due" : "Paid";

                                return (
                                  <tr key={student?.id}>
                                    {/* =====================================================
                #
            ====================================================== */}
                                    <td className="ps-4 fw-semibold">
                                      {i + 1}
                                    </td>

                                    {/* =====================================================
                STUDENT
            ====================================================== */}
                                    <td>
                                      <div className="d-flex align-items-center gap-1 mb-1">
                                        <span className="badge bg-light text-dark border">
                                          {student.registration_no}
                                        </span>

                                        {student.student_batch_n_fees?.[0]
                                          ?.rte_status === "RTE" && (
                                          <span className="badge bg-success-subtle text-success border">
                                            RTE
                                          </span>
                                        )}
                                      </div>

                                      <div className="fw-semibold">
                                        {student.name}
                                      </div>

                                      {student.father_name && (
                                        <small className="text-muted">
                                          S/O {student.father_name}
                                        </small>
                                      )}
                                    </td>

                                    {/* =====================================================
                                          BATCH FEE
                                      ====================================================== */}
                                    <td className="text-end">
                                      {/* Total Fee */}

                                      {/* Payable Fee */}
                                      <div className="fw-bold text-success mb-2">
                                        {/* <small>Payable</small>

                                        <br /> */}
                                        <del className="text-muted me-2">
                                          {inr(batch_total_fee)}
                                        </del>
                                        {inr(batchFee)}
                                      </div>

                                      {/* Fee Type Breakdown */}
                                      {Object.keys(feeTypeTotals).length >
                                        0 && (
                                        <div className="border-top pt-2 mt-2">
                                          <div className="text-start">
                                            <small className="text-muted fw-semibold">
                                              Fee Breakdown
                                            </small>
                                          </div>

                                          {Object.entries(feeTypeTotals).map(
                                            ([feeType, values]) => (
                                              <div
                                                key={feeType}
                                                className="d-flex justify-content-between align-items-center gap-3 small mt-1"
                                              >
                                                <span className="text-muted text-start">
                                                  {feeType}
                                                </span>

                                                <span className="fw-semibold text-nowrap">
                                                  {inr(values.final)}
                                                </span>
                                              </div>
                                            ),
                                          )}
                                        </div>
                                      )}
                                    </td>

                                    {/* =====================================================
                HOSTEL
            ====================================================== */}
                                    <td className="text-end">
                                      {hostelFee > 0 ? (
                                        <>
                                          <div className="fw-semibold">
                                            {inr(hostelFee)}
                                          </div>

                                          {hostelDue > 0 && (
                                            <small className="text-warning">
                                              Due: {inr(hostelDue)}
                                            </small>
                                          )}
                                        </>
                                      ) : (
                                        <span className="text-muted">-</span>
                                      )}
                                    </td>

                                    {/* =====================================================
                LIBRARY
            ====================================================== */}
                                    <td className="text-end">
                                      {libraryFee > 0 ? (
                                        <>
                                          <div className="fw-semibold">
                                            {inr(libraryFee)}
                                          </div>

                                          {libraryDue > 0 && (
                                            <small className="text-warning">
                                              Due: {inr(libraryDue)}
                                            </small>
                                          )}
                                        </>
                                      ) : (
                                        <span className="text-muted">-</span>
                                      )}
                                    </td>

                                    {/* =====================================================
                TRANSPORT
            ====================================================== */}
                                    <td className="text-end">
                                      {transportFee > 0 ? (
                                        <>
                                          <div className="fw-semibold">
                                            {inr(transportFee)}
                                          </div>

                                          {transportDue > 0 && (
                                            <small className="text-warning">
                                              Due: {inr(transportDue)}
                                            </small>
                                          )}
                                        </>
                                      ) : (
                                        <span className="text-muted">-</span>
                                      )}
                                    </td>

                                    {/* =====================================================
                DISCOUNT
            ====================================================== */}
                                    <td className="text-end text-danger">
                                      {batchDiscount > 0
                                        ? inr(batchDiscount)
                                        : "-"}
                                    </td>

                                    {/* =====================================================
                PAYABLE
            ====================================================== */}
                                    <td className="text-end fw-semibold">
                                      {inr(totalPayable)}
                                    </td>

                                    {/* =====================================================
                PAID
            ====================================================== */}
                                    <td className="text-end text-success fw-semibold">
                                      {inr(totalPaid)}
                                    </td>

                                    {/* =====================================================
                DUE
            ====================================================== */}
                                    <td className="text-end text-warning fw-semibold">
                                      {inr(totalDue)}
                                    </td>

                                    {/* =====================================================
                STATUS
            ====================================================== */}
                                    <td className="text-center pe-4">
                                      {feeStatus === "Paid" ? (
                                        <span className="badge bg-success-subtle text-success">
                                          Paid
                                        </span>
                                      ) : (
                                        <>
                                          <span className="badge bg-warning-subtle text-warning">
                                            Due
                                          </span>
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                            )}
                          </tbody>

                          {/* ===============================================================
                                      TOTAL FOOTER
                                  ================================================================ */}
                          {!!BatchStudents?.length && (
                            <tfoot>
                              {(() => {
                                const totals = BatchStudents.reduce(
                                  (acc, student) => {
                                    const batchFees =
                                      student.student_batch_n_fees || [];

                                    const hostelFees =
                                      student.student_hostel_n_fees || [];

                                    const libraryFees =
                                      student.student_library_n_fees || [];

                                    const transportFees =
                                      student.student_transport_n_fees || [];

                                    /*
                                     * Batch
                                     */
                                    acc.batchFee += batchFees.reduce(
                                      (t, f) => t + Number(f.final_fee || 0),
                                      0,
                                    );

                                    acc.batchTotalFee += batchFees.reduce(
                                      (t, f) => t + Number(f.total_fee || 0),
                                      0,
                                    );

                                    acc.discount += batchFees.reduce(
                                      (t, f) =>
                                        t + Number(f.total_discount || 0),
                                      0,
                                    );

                                    /*
                                     * Batch Fee Types
                                     */
                                    batchFees.forEach((batchFee) => {
                                      const details =
                                        batchFee.student_fee_details || [];

                                      details.forEach((fee) => {
                                        const feeType =
                                          fee.fee_type || "Other Fee";

                                        if (!acc.feeTypes[feeType]) {
                                          acc.feeTypes[feeType] = {
                                            actual: 0,
                                            discount: 0,
                                            final: 0,
                                            paid: 0,
                                            due: 0,
                                          };
                                        }

                                        acc.feeTypes[feeType].actual += Number(
                                          fee.actual_amount || 0,
                                        );

                                        acc.feeTypes[feeType].discount +=
                                          Number(fee.discount || 0);

                                        acc.feeTypes[feeType].final += Number(
                                          fee.final_amount || 0,
                                        );

                                        acc.feeTypes[feeType].paid += Number(
                                          fee.paid_amount || 0,
                                        );

                                        acc.feeTypes[feeType].due += Number(
                                          fee.due_amount || 0,
                                        );
                                      });
                                    });

                                    /*
                                     * Hostel
                                     */
                                    acc.hostel += hostelFees.reduce(
                                      (t, f) => t + Number(f.final_amount || 0),
                                      0,
                                    );

                                    /*
                                     * Library
                                     */
                                    acc.library += libraryFees.reduce(
                                      (t, f) => t + Number(f.final_amount || 0),
                                      0,
                                    );

                                    /*
                                     * Transport
                                     */
                                    acc.transport += transportFees.reduce(
                                      (t, f) => t + Number(f.final_amount || 0),
                                      0,
                                    );

                                    /*
                                     * Paid
                                     */
                                    acc.paid +=
                                      batchFees.reduce(
                                        (t, f) => t + Number(f.total_paid || 0),
                                        0,
                                      ) +
                                      hostelFees.reduce(
                                        (t, f) =>
                                          t + Number(f.paid_amount || 0),
                                        0,
                                      ) +
                                      libraryFees.reduce(
                                        (t, f) =>
                                          t + Number(f.paid_amount || 0),
                                        0,
                                      ) +
                                      transportFees.reduce(
                                        (t, f) =>
                                          t + Number(f.paid_amount || 0),
                                        0,
                                      );

                                    /*
                                     * Due
                                     */
                                    acc.due +=
                                      batchFees.reduce(
                                        (t, f) => t + Number(f.total_due || 0),
                                        0,
                                      ) +
                                      hostelFees.reduce(
                                        (t, f) =>
                                          t + Number(f.left_amount || 0),
                                        0,
                                      ) +
                                      libraryFees.reduce(
                                        (t, f) =>
                                          t + Number(f.left_amount || 0),
                                        0,
                                      ) +
                                      transportFees.reduce(
                                        (t, f) =>
                                          t + Number(f.left_amount || 0),
                                        0,
                                      );

                                    return acc;
                                  },
                                  {
                                    batchFee: 0,
                                    batchTotalFee: 0,
                                    hostel: 0,
                                    library: 0,
                                    transport: 0,
                                    discount: 0,
                                    paid: 0,
                                    due: 0,
                                    feeTypes: {},
                                  },
                                );

                                const totalPayable =
                                  totals.batchFee +
                                  totals.hostel +
                                  totals.library +
                                  totals.transport;

                                return (
                                  <>
                                    {/* Main Total Row */}
                                    <tr className="table-light fw-bold">
                                      <td className="ps-4"></td>

                                      <td>
                                        Total {BatchStudents.length} Students
                                      </td>

                                      {/* Batch Fee */}
                                      <td className="text-end">
                                        <div>
                                          <small className="text-muted">
                                            Total
                                          </small>
                                          <br />

                                          <del className="text-muted">
                                            {inr(totals.batchTotalFee)}
                                          </del>
                                        </div>

                                        <div className="text-success">
                                          <small>Payable</small>
                                          <br />

                                          {inr(totals.batchFee)}
                                        </div>
                                      </td>

                                      {/* Hostel */}
                                      <td className="text-end">
                                        {inr(totals.hostel)}
                                      </td>

                                      {/* Library */}
                                      <td className="text-end">
                                        {inr(totals.library)}
                                      </td>

                                      {/* Transport */}
                                      <td className="text-end">
                                        {inr(totals.transport)}
                                      </td>

                                      {/* Discount */}
                                      <td className="text-end text-danger">
                                        {inr(totals.discount)}
                                      </td>

                                      {/* Payable */}
                                      <td className="text-end">
                                        {inr(totalPayable)}
                                      </td>

                                      {/* Paid */}
                                      <td className="text-end text-success">
                                        {inr(totals.paid)}
                                      </td>

                                      {/* Due */}
                                      <td className="text-end text-warning">
                                        {inr(totals.due)}
                                      </td>

                                      <td></td>
                                    </tr>

                                    {/* =====================================================
                FEE TYPE TOTAL BREAKDOWN
            ====================================================== */}
                                    {Object.keys(totals.feeTypes).length >
                                      0 && (
                                      <tr className="table-light">
                                        <td></td>

                                        <td colSpan="10" className="py-3">
                                          <div className="fw-semibold mb-2">
                                            Batch Fee Type Breakdown
                                          </div>

                                          <div className="d-flex flex-wrap gap-2">
                                            {Object.entries(
                                              totals.feeTypes,
                                            ).map(([feeType, values]) => (
                                              <div
                                                key={feeType}
                                                className="border rounded px-3 py-2 bg-white"
                                              >
                                                <div className="small text-muted">
                                                  {feeType}
                                                </div>

                                                <div className="fw-bold">
                                                  {inr(values.final)}
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </>
                                );
                              })()}
                            </tfoot>
                          )}
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
